export class MeasuringReason {

    public id: number;
    public name: string;

    constructor(measuringReason: any = {}) {
        this.id = measuringReason.id;
        this.name = measuringReason.name || '';
    }
}
